import {convertUniversalDateToPersianDate} from "../../util/DateConvertor";
import React from "react";
import "./Dashboard.scss"

export default function TicketInDashboard({key, title, firstName, sendAt, status, handleShowMessageInDashboard}) {
    return (
        <div className={"ticketContainer"} key={key} onClick={handleShowMessageInDashboard}>
            <div className={"ticketContent"}>
                <span>{title}</span>
                <span className={"statusContainer"}>
                    {status === "REVIEWED" ? <span className={"reviewed"}>بررسی شده</span> :
                        <span className={"awaitingForReview"}>در حال بررسی</span>}
                </span>
            </div>
            <span>{firstName ? `${firstName}` : "-"}</span>
            <span>{convertUniversalDateToPersianDate(sendAt)}</span>

        </div>
    )
}